<script>
import { mapGetters } from "vuex";
import Breadcrumbs from "@/components/ui/Breadcrumbs.vue";
import Bahn1EventDetails from "@/components/ui/Bahn1/Bahn1EventDetails.vue";
import Bahn1FeedbackBanner from "@/components/ui/Bahn1/Bahn1FeedbackBanner.vue";

export default {
  name: "Bahn1EventInfo",
  components: { Breadcrumbs, Bahn1EventDetails, Bahn1FeedbackBanner },
  data: () => ({
    //TODO: swap for the correct visual once available
    heroImage: require("@/assets/BAHN1.png")
  }),
  computed: {
    ...mapGetters("bahn1", ["postEvent"]),
    heroStyle() {
      return {
        backgroundImage:
          "linear-gradient(0deg, #00285BF2 0%, #008CC873 59%, #69717900 100%), " +
          `url(${this.heroImage})`
      };
    }
  },
  methods: {
    scrollTo(id) {
      const el = document.getElementById(id);
      if (el) window.scroll({ top: el.offsetTop, behavior: "smooth" });
    }
  }
};
</script>

<template>
  <div class="bahn1-event-info">
    <div class="hero" :style="heroStyle">
      <breadcrumbs class="breadcrumbs" />

      <div class="hero-content">
        <div class="hero-text">
          <h1 class="highlight">BAHN 1</h1>
          <br />
          <h2 class="highlight">Impulse für die Bäder von morgen</h2>
          <p>
            Die Veranstaltungsreihe der NEW zur Zukunft kommunaler Bäder für
            Entscheider:innen aus Kommunen und Bäderbetrieben - von der
            Verwaltungsspitze über Fachdezernate bis zur Betriebsleitung.
          </p>
        </div>

        <div class="hero-actions" v-if="!postEvent">
          <v-btn class="anmeldung" @click="scrollTo('bahn1-anmeldung')">
            Jetzt anmelden
          </v-btn>
          <v-btn class="agenda" @click="scrollTo('bahn1-agenda')">
            Programm ansehen
          </v-btn>
        </div>
      </div>
    </div>

    <bahn1-event-details v-if="!postEvent" />
    <bahn1-feedback-banner v-else />
  </div>
</template>

<style scoped>
.bahn1-event-info {
  width: 100%;
  border-radius: 5px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.breadcrumbs {
  color: #1f2b37;
}
.highlight {
  display: inline;
  background-color: #004ba0;
  padding: 8px 16px 6px 12px;
}
.hero h1.highlight {
  font-family: "GeometriaMedium";
  font-size: 60px;
  font-size: clamp(24px, 6.24cqw, 60px);
}
.hero h2.highlight {
  font-family: "GeometriaGeometria";
  font-size: 30px;
  font-size: clamp(16px, 3.12cqw, 30px);
}
.hero {
  position: relative;
  container-type: inline-size;
  aspect-ratio: 16 / 7;
  min-height: 420px;
  overflow: hidden;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 16px 24px;
  color: white;
}
.hero-content {
  position: absolute;
  top: 30%;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 0 24px;
  display: flex;
  flex-direction: column;
}
.hero-text {
  width: 100%;
}
.hero-actions {
  display: flex;
  gap: 12px;
  margin-top: auto;
  margin-bottom: auto;
}
p {
  margin-top: 24px;
  margin-bottom: 0;
  font-size: 24px;
  font-size: clamp(14px, 2.49cqw, 24px);
  font-family: "GeometriaLight";
}
.anmeldung {
  background: white;
  border: 1px solid white;
  font-family: "GeometriaMedium";
  color: #004ba0;
  padding: 12px 32px 12px 32px;
}
.agenda {
  background: transparent !important;
  border: 1px solid white;
  font-family: "GeometriaMedium";
  color: white;
  padding: 12px 32px 12px 32px;
}
@media (max-width: 599px) {
  .hero {
    aspect-ratio: auto;
    min-height: auto;
    padding-bottom: 24px;
  }
  .hero-content {
    position: static;
    padding: 0;
  }
  .hero-actions {
    flex-direction: column;
    align-items: flex-start;
    margin-top: 24px;
    margin-bottom: 0;
  }
}
</style>
